import React, { Component } from 'react';
import Footer from '../../components/Footer/Footer';
import PostHeader from '../../components/Header/PostHeader';
import '../../pages/Profile/Profile.scss';
import image from '../../Assets/images/commonImages/DESKTOP-ASTOUND-BANNER.webp';
import image1 from '../../Assets/images/commonImages/IPAD-ASTOUND-BANNER.webp';
import image2 from '../../Assets/images/commonImages/IPAD-ASTOUND-BANNER.webp';
import { profilePage } from '../../global/texts/postActivation/profile';
import Skeleton from 'react-loading-skeleton';
import { bindActionCreators } from 'redux';
import * as Action from '../../store/Checkout/actions';
import { connect } from 'react-redux';
import _ from 'lodash';
import SimpleHeader from '../../components/Header/simpleHeader';
// import { pushTrackingEventsToGAAndFB } from '../../global/commonFunctions/GaAndFb';
import { CircularProgress } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { seoData } from '../../global/seoData';
import { globalVal } from '../../global/globalvalues';

type initialProps = {
    history: any;
    CheckoutActions: any;
    CheckoutState: any;
    BillingState: any;
};
type initialState = {
    isLoader: boolean;
    user: any;
    proAddresAddress: any;
    proAddresAddress2: any;
    proAddresCity: any;
    proAddresState: any;
    proAddresCounty: any;
    proAddresZip: any;
};
export class Profile extends Component<initialProps, initialState> {
    dateref: any = React.createRef();
    state: initialState = {
        isLoader: true,
        user: {
            firstName: '',
            lastName: '',
            emailId: '',
            primaryNumber: '',
            password: '',
        },
        proAddresAddress: null,
        proAddresAddress2: null,
        proAddresCity: null,
        proAddresState: null,
        proAddresCounty: null,
        proAddresZip: null,
    };

    componentDidMount() {
        window.scroll(0, 0);

        let currentUser: any = localStorage.getItem('customerDetail');
        currentUser = JSON.parse(currentUser);
        if (currentUser) {
            this.setState({
                user: currentUser,
                isLoader: false,
            });
        }
        if (currentUser && currentUser.addresses) {
            let addre: any =
                currentUser.addresses.length > 0 && currentUser.addresses.find((el: any) => el.type === 'billing');
            if (addre) {
                this.setState({
                    proAddresAddress: addre.address1,
                    proAddresAddress2: addre.address2,
                    proAddresCity: addre.city,
                    proAddresState: addre.state,
                    proAddresCounty: addre.country,
                    proAddresZip: addre.zip,
                });
            }
        }
    }

    // GAAndFBEventsHandler = (category: string, actionType: string) => {
    //     pushTrackingEventsToGAAndFB({
    //         category: category,
    //         actionType: actionType,
    //     });
    // };

    render() {
        const { user } = this.state;

        return (
            <div className="ProfileMain">
                <Helmet>
                <title>{seoData.profile.title}</title>
                <meta property="og:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                <meta property="og:title" name="title" content={seoData.profile.title} />
                <meta property="og:description" name="description" content={seoData.profile.description} />
                <meta name="description" content={seoData.profile.description} />
                <meta name="keywords" content={seoData.profile.keywords} />
                <meta name="robots" content="noindex, nofollow" />
                <meta property="twitter:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                <meta name="twitter:title" content={seoData.profile.title} />
                <meta name="twitter:description" content={seoData.profile.description} />
                <link rel="canonical" href={seoData.profile.canonicalUrl} />
            </Helmet>
                {(this.state.user.simPaid && this.state.user.status === 0) ||
                this.state.user.status === 1 ||
                this.state.user.status === 8 ||
                this.state.user.status === 9 ||
                this.state.user.status === 10 ||
                this.state.user.status === 11 ? (
                    <SimpleHeader history={this.props.history} user={this.state.user} isHelp={true} />
                ) : (
                    <PostHeader 
                        history={this.props.history}
                        showServiceTab= {this.props.BillingState?.config?.data?.configs?.SERVICE_TAB === 'ENABLE' ? true : false} 
                        // enableServiceInPrimarySus={this.props.BillingState?.config?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED} 
                    />
                )}

                <div className="OverlayPostProfile">
                    <div className="carouseImage">
                        <img className="web" width="100%" src={image} alt="illustration" />
                        <img className="iPadPro" src={image1} height="400" alt="illustration" />
                        <img className="iPad" src={image2} height="400" alt="illustration" />
                        <div className="contentCarousel">
                            <h1 style={{ display: 'none' }}>Your Profile</h1>
                            <div className="Goodbye-mobile-store">
                                {this.state.isLoader ? <Skeleton className="skeletonRadius" /> : profilePage.overlay}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="customBannerMobile">Profile</div>

                <div className="ProfileBlock">
                    {user ? (
                        <>
                            <div className="ProfileRow">
                                <div className="NameCol">
                                    <div className="ProfileCol">
                                        <label>First Name</label>
                                        <div className='username'>{user && user.firstName || '--'}</div>
                                    </div>
                                    <div className="ProfileCol">
                                        <label>Last Name</label>
                                        <div className='username'>{user && user.lastName || '--'}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="ProfileRow">
                                <label>Account Number</label>
                                <div>{user && user?.meta?.customer_statement_number || '--'}</div>
                            </div>
                            <div className="ProfileRow">
                                <label>Email</label>
                                <div>{user && user.emailId || '--'}</div>
                            </div>
                            <div className="ProfileRow">
                                <label>Billing Address</label>
                                <div>
                                    {this.state.proAddresAddress}
                                    {', '}
                                    {this.state.proAddresAddress2 && this.state.proAddresAddress2 + ', '}
                                    {this.state.proAddresCity}
                                    {', '}
                                    {this.state.proAddresState}
                                    {', '}
                                    {this.state.proAddresCounty}
                                    {', '}
                                    {this.state.proAddresZip}
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="text-center">
                            <CircularProgress />
                        </div>
                    )}
                </div>
                <Footer />
            </div>
        );
    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        CheckoutActions: bindActionCreators(Action, dispatch),
    };
}
const mapStateToProps = (state: any) => ({
    CheckoutState: state.checkout,
    BillingState: state.billing,
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
